export default class FormLegacyHelper {
    public static setValidation($context, errors) {
        $context = $context || $("body");
        var $validationSummary = $("[data-valmsg-summary]", $context);
        $validationSummary.addClass("validation-summary-errors").removeClass("validation-summary-valid");
        var ul = $("ul", $validationSummary).empty();

        $.each(errors, function (i, item) {
            ul.append("<li>" + item.Errors + "</li>");
            var upperCaseName = item.Name.charAt(0).toUpperCase() + item.Name.slice(1);
            $context.find("*[data-valmsg-for='" + item.Name + "'],*[data-valmsg-for='" + upperCaseName + "']").html(item.Errors).addClass("field-validation-error");
            $context.find("*[name='" + item.Name + "'],*[name='" + upperCaseName + "']").addClass("input-validation-error");
        });
    }

    public static resetValidation($context) {
        $context = $context || $("body");
        var $validationSummary = $("[data-valmsg-summary]", $context);
        $validationSummary.addClass("validation-summary-valid").removeClass("validation-summary-errors");
        var ul = $("ul", $validationSummary).empty();
        $(".field-validation-error", $context).addClass("field-validation-valid").removeClass("field-validation-error").empty();
        $(".input-validation-error", $context).addClass('input-validation-valid').removeClass("input-validation-error");
    };

    public static disableControls($context) {
        $context = $context || $("body");
        var $disableOnSubmit = $(".disable-on-submit", $context);
        $disableOnSubmit.attr("disabled", "disabled");
    }

    public static enableControls($context) {
        var $context = $context || $("body");
        var $disableOnSubmit = $(".disable-on-submit", $context);
        $disableOnSubmit.removeAttr("disabled");
    }

    public static async setVueValidation(validationState) {
        if (validationState) {
            for (var field in validationState) {
                let control = document.getElementsByName(field)[0];
                if (control) {
                    control.classList.add("input-validation-error");
                }
            }
        }
    }

    public static resetVueValidation() {
        let inputs = document.getElementsByClassName("input-validation-error");
        for (let i = 0; i < inputs.length; i++) {
            inputs[i].classList.remove("input-validation-error");
        }
    }
}